'use strict';

var toInteger = require('./to-integer')

  , max = Math.max;

module.exports = function (value) { return max(0, toInteger(value)); };



//////////////////
// WEBPACK FOOTER
// ../~/es5-ext/number/to-pos-integer.js
// module id = 161
// module chunks = 0